import { useReducer } from 'react'

export const useToggle = (initialValue: boolean = false) => {
  // see: https://twitter.com/gabe_ragland/status/1339339833580290048
  // useRedcer returns [value, toggle] and React guarantees `toggle` to have a stable identity
  return useReducer(state => !state, initialValue)
}
